module.exports = __webpack_public_path__ + "images/avatars/female/4.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/4.svg
// module id = V5IG
// module chunks = 153